import { DURING_STAY_SURVEY_GET_ANSWER } from './../const';

function action(token, lang, context) {
  return { type: DURING_STAY_SURVEY_GET_ANSWER, token, lang, context };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/duringStaySurveyGetAnswer.js